import {all} from 'redux-saga/effects';

import addressesSaga from './address-saga';
import appSaga from './app-saga';
import basketSaga from './basket-saga';
import campaignSaga from './campaign-saga';
import recommendationsSaga from './recommendations-saga';

export default function* rootSaga() {
  yield all([appSaga(), basketSaga(), addressesSaga(), recommendationsSaga(), campaignSaga()]);
}
